import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, sm },
} = constants.breakpoints;
const greyLight = constants.colors.ui.neutral[100];
const white = constants.colors.ui.white[50];

export const rootCss = {
  width: "inherit",
  display: "grid",
  gridAutoFlow: "column",
  gridTemplateColumns: "repeat(2, 136px)",
  columnGap: "16px",
  justifyContent: "center",
  borderTop: `1px solid ${greyLight}`,
  backgroundColor: white,

  "> :only-child": {
    width: "100%",
    maxWidth: "288px",
    gridColumn: "1/-1",
    placeSelf: "center",
  },

  padding: "16px 16px 32px 16px",

  [mediaQuery.downTo(sm)]: {
    padding: "16px 40px",
    gridTemplateColumns: "repeat(2, 155px)",

    "> :only-child": {
      maxWidth: "327px",
    },
  },

  [mediaQuery.downTo(md)]: {
    padding: "16px 32px",
  },
};

export const buttonCss = {
  width: "100%",
  justifyContent: "center",
};
